import axiosService from '../utils/axios';
import { getRecentlyViewedProfileIds, recordSyncTime } from '../utils/storage';

/**
 * Syncs the locally stored viewed profiles with the server
 * @param userId The ID of the current user
 * @returns A promise that resolves when the sync is complete
 */
export async function syncViewedProfiles(userId: string): Promise<void> {
    try {
    // Get the list of viewed profile IDs from localStorage
        const viewedProfileIds = getRecentlyViewedProfileIds();

        // Only sync if we have viewed profiles
        if (viewedProfileIds.length === 0) {
            recordSyncTime(); // Record sync time even if we didn't sync
            return;
        }

        // Fixed API path to match the backend route
        await axiosService.post(`/profile/sync-viewed/${userId}`, {
            viewedProfiles: viewedProfileIds
        });

        // Record the sync time
        recordSyncTime();
    } catch (error) {
        console.error('Error syncing viewed profiles with server:', error);
    // Don't record sync time on error so we'll try again next time
    }
}
